import {CURRENCIES_LIST} from "@/public/components/elements/dashboard/constants";

export const state = {
    dates: [],
    orders: [],
    transactionsCount: [],
    payments: [],
    balances: [],
    transactions: [],
    deposit: [],
    withdrawal: [],
    currenciesList: CURRENCIES_LIST,
    isInfoOpened: false,
    infoPayload: {},
    dashboardRawData: {},
    currentWallet: 'usd',
    currentInterval: 14,
};
